import React from "react";
import { Link } from "react-router-dom";
import { Img } from "./shared/img";

import { useTranslationsById } from "../hooks/use-translations-by-id";

/**
 * Retorna la franja de FAQs y Contáctanos
 * @returns {JSX.Element} Faqs
 */
export const CallToAction = ({ text }) => {
    const texts = useTranslationsById({ mainSectionName: "que_es_home" });

    return (
        <div className="p-3 py-4 callToAction">
            <div className="container">
                <div className="d-md-flex justify-content-center">
                    <div
                        className="col-12 col-lg-7 col-lg d-flex flex-column justify-content-center align-items-center"
                        style={{ maxWidth: 600 }}
                    >
                        <div>
                            <h2
                                className="text-center text-md-left secondary-font w-100 title4"
                            >
                                {text ? text : "N/A"}
                            </h2>

                            <div className="py-3">
                                <Link
                                    className="inverse-primary-button py-2 px-5 my-4 mr-md-3 focusable-red d-block d-md-inline"
                                    to="/contacto/cita"
                                >
                                    {texts.getText({
                                        id: 'button.demo',
                                        defaultText: 'Solicita un demo',
                                    })}
                                    </Link>
                                {/* <Link
                                    className="inverse-primary-button py-2 px-3 focusable-red d-block d-md-inline"
                                    to="/ayuda-sin-login"
                                >{faqsTexts?.fqs || 'FAQs'}</Link> */}
                            </div>
                        </div>

                    </div>
                    <div className="col d-none d-lg-flex">
                        <div className="img-boletin"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}